import { fetchOfferList } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import getOfferListKey from 'lib/offer/offerListKey'
import { shallowEqual } from 'react-redux'

function useDestinationOfferList(
  destinations: Array<App.DestinationInfo>,
  filters: App.OfferListFilters,
): [App.OfferList, App.OfferList] {
  const dispatch = useAppDispatch()

  useEffect(() => {
    destinations.forEach(destination => {
      dispatch(fetchOfferList({ ...filters, destinationId: destination.id }))
      dispatch(fetchOfferList({ ...filters, holidayTypes: ['Limited Time LUX Exclusive'], destinationId: destination.id }))
    })
  }, [destinations, dispatch, filters])

  const [offerLists, flashOfferLists] = useAppSelector((state) => {
    const offerLists = destinations.map(destination =>
      state.offer.offerLists[getOfferListKey({ ...filters, destinationId: destination.id })],
    )

    const flashOfferLists = destinations.map(destination =>
      state.offer.offerLists[getOfferListKey({ ...filters, holidayTypes: ['Limited Time LUX Exclusive'], destinationId: destination.id })],
    )

    return [offerLists, flashOfferLists]
  }, shallowEqual)

  return [
    offerLists,
    flashOfferLists,
  ]
}

export default useDestinationOfferList
